import QRCode from "qrcode";
import { QRAuth } from "@/vue-core/models/entrance/qrauth.model";
/**
 * Generates a QR code with the user information of an event, uid and courses
 * @param {QRAuth} qrData an object of a qr auth type of data  QRAuth  defined in the vue-core submodule
 * @return {string} base64 data string of the image to be saved in firestore as the QR code image.
 */
export const generateQR = async (qrData: QRAuth): Promise<string> => {
  return await QRCode.toDataURL(JSON.stringify(qrData));
};
